<div *ngIf="{ adConfigs: adConfigs$ | async } as subs" class="bg-900">
  <flo-lazy
    [componentConstructor]="AdComponent"
    [initialProps]="subs.adConfigs | mapGet: 'interstitial'"
  ></flo-lazy>
</div>
<div *ngIf="accumulatedWatchSections$ | async as sections" class="watch pb-4 pb-lg-5 bg-900" data-test="watch">
  <!-- DESKTOP LEADERBOARD AD -->
  <div class="py-4 mb-4 d-none d-lg-block leaderboard-center border-bottom border-grey-800 lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardDesktopAdProps"
      [detectorHeight]="90"
    ></flo-lazy>
  </div>
  <!-- TABLET LEADERBOARD AD -->
  <div class="py-3 mb-4 d-none d-md-block d-lg-none leaderboard-center border-bottom border-grey-800 lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardTabletAdProps"
      [detectorHeight]="90"
    ></flo-lazy>
  </div>
  <!-- MOBILE LEADERBOARD AD -->
  <div class="py-3 mb-4 d-md-none leaderboard-center border-bottom border-grey-800">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardMobileAdProps"
      [detectorHeight]="50"
    ></flo-lazy>
  </div>
  <ng-container *ngFor="let section of sections; let i = index; trackBy: trackBySectionId">
    <ng-container *ngIf="section.items_style === 'shortcut'">
      <div class="container watch__quick-links bg-900 m-sm-0 m-md-auto" data-test="watch-quick-links">
        <div class="row watch__quick-links--title d-flex flex-column col-9">
          <div class="d-none d-lg-block p-3 px-lg-0">
            <h2 class="watch__quick-links--title overtext font-family-heavy color-200 mb-0 text-line-clamp-2">Browse By Category</h2>
          </div>
        </div>
        <div class="row d-flex flex-nowrap horizontal-scroll">
          <ng-container *ngFor="let item of section.items; first as isFirst; trackBy: trackByItem;">
            <a
              floAnalytics
              [eventName]="'Filter Applied'"
              [name]="item.title"
              class="watch__quick-links--badge badge rounded-pill me-25 border bg-800 border-grey-800 color-200 footnote scroll-item"
              [ngClass]="{ 'ms-3 ms-lg-0': isFirst }"
              [routerLink]="item.url"
            >
              {{ item.title }}
            </a>
          </ng-container>
          <!-- IMPORTANT: DO NOT REMOVE THE DIV BELOW -->
          <!-- This serves as the "last child" to work around the browser bug that prevents margin/padding
                on the furthest right child of an overflow-x: auto horizontally scrolling div. -->
          <div class="watch__quick-links--mobile-spacer d-block d-lg-none">&nbsp;</div>
        </div>
      </div>
    </ng-container>
    <!-- PLACE AD AFTER THE 2ND, 5TH, 8TH (ETC.) SECTIONS -->
    <ng-container *ngIf="((i - 2) % 3) === 0">
      <!-- INLINE DESKTOP AD -->
      <div class="py-4 mt-5 d-none d-lg-block leaderboard-center border-top border-bottom border-grey-800 lazy-leaderboard-container">
        <flo-lazy
          [componentConstructor]="AdComponent"
          [initialProps]="getInlineAdProps(adSizes.desktop, i)"
          [detectorHeight]="90"
        ></flo-lazy>
      </div>
      <!-- INLINE TABLET AD -->
      <div class="py-4 mt-4 d-none d-md-block d-lg-none leaderboard-center border-top border-bottom border-grey-800 lazy-leaderboard-container">
        <flo-lazy
          [componentConstructor]="AdComponent"
          [initialProps]="getInlineAdProps(adSizes.tablet, i)"
          [detectorHeight]="90"
        ></flo-lazy>
      </div>
      <!-- INLINE MOBILE AD -->
      <div class="py-4 mt-4 d-md-none leaderboard-center border-top border-bottom border-grey-800 lazy-leaderboard-container">
        <flo-lazy
          [componentConstructor]="AdComponent"
          [initialProps]="getInlineAdProps(adSizes.mobileInline, i, true)"
          [detectorHeight]="50"
        ></flo-lazy>
      </div>
    </ng-container>

    <!-- favorites -->
    <ng-container *ngIf="section.title === 'Favorites'">
      <div class="container  bg-900 mt-4" data-test="watch-favorites-header">
        <div class="row d-flex justify-content-between align-items-end">
          <div class="d-flex flex-column col-9 p-3 px-lg-0">
            <h2 class="overtext font-family-heavy color-200 mb-0 text-line-clamp-2">{{ section.title }}</h2>
          </div>
        </div>
      </div>
      <div class="dark-theme col-12 p-0" [ngClass]="{'fade-in': section.fadeIn}">
        <flo-watch-carousel>
          <ng-container *ngFor="let item of section.items; trackBy: trackByItem;">
              <flo-avatar-card
                class="col-3 px-0 mx-3 mx-lg-0 me-lg-3"
                [href]="item.action.url"
                [primaryLabel]="item.title"
                [secondaryLabel]="item.subtitle_1"
                [image]="item.preview_image.url">
              </flo-avatar-card>
          </ng-container>
        </flo-watch-carousel>
      </div>
    </ng-container>

    <ng-container *ngIf="section.type === 'cta-card'">
      <div class="container bg-900 px-0 py-6">
        <flo-personalization-cta
          [image]="section.icon_image.url"
          [title]="section.title"
          [subtitle]="section.subtitle"
          [btnTitle]="section.action.title"
          [href]="section.action.url"
        >
        </flo-personalization-cta>
      </div>
    </ng-container>

    <ng-container *ngIf="section.type === 'placeholder'">
      <flo-skeleton [theme]="'my-stuff'"></flo-skeleton>
    </ng-container>
    <!-- end favorites -->

    <ng-container *ngIf="section.items_style === 'large-card'">
      <div class="container watch__large-cards--header bg-900 mt-4">
        <div class="row d-flex justify-content-between align-items-end">
          <div class="watch__large-cards--title-description d-flex flex-column col-9 p-3 px-lg-0">
            <ng-container *ngIf="section.action?.url; else noLargeCardLink">
              <a
                floAnalytics
                elementName="Collection Name"
                class="watch__large-cards--title overtext font-family-heavy color-200 hover-grey-200 hover-underline mb-0 text-line-clamp-2"
                [routerLink]="section.action.url"
              >
                {{ section.title }}
              </a>
            </ng-container>
            <ng-template #noLargeCardLink>
              <h2 class="watch__large-cards--title overtext font-family-heavy color-200 mb-0 text-line-clamp-2">{{ section.title }}</h2>
            </ng-template>
            <span *ngIf="section.description" class="watch__large-cards--description footnote color-500">{{ section.description }}</span>
          </div>
          <div *ngIf="section.action" class="watch__large-cards--view-all d-flex justify-content-end col-3 px-0 py-md-3">
            <a
              floAnalytics
              tagName="Button"
              elementName="See All Videos"
              [analyticsProperties]="{ collection_name: section.title }"
              class="footnote p-3 p-md-0 color-500"
              [routerLink]="section.action.url"
            >
              {{ section.action.title }}
            </a>
          </div>
        </div>
      </div>
      <div class="dark-theme col-12 watch__large-cards--items p-0" [ngClass]="{'fade-in': section.fadeIn}">
        <flo-watch-carousel>
          <ng-container *ngFor="let item of section.items; trackBy: trackByItem;" [ngSwitch]="item.type">
            <div class="large__rail__item">
              <flo-large-event-card *ngSwitchCase="'event'" [props]="item" [geoBlockedIds]="geoBlockedIds$ | async"
                                    [previewStreamTokens]="previewStreamTokens$ | async" (streamDisplayed)="sendPreviewStreamDisplayed($event)"></flo-large-event-card>
              <flo-large-content-card *ngSwitchDefault [props]="item"></flo-large-content-card>
            </div>
          </ng-container>
        </flo-watch-carousel>
      </div>
    </ng-container>
    <ng-container *ngIf="section.items_style === 'featured-card'">
      <div class="container watch__featured-cards--header bg-900 mt-4" data-test="watch-featured-cards-header">
        <div class="row d-flex justify-content-between align-items-end">
          <div class="watch__featured-cards--title-description d-flex flex-column col-9 p-3 px-lg-0">
            <h2 class="watch__featured-cards--title overtext font-family-heavy color-200 mb-0 text-line-clamp-2">{{ section.title }}</h2>
          </div>
        </div>
      </div>
      <div class="dark-theme col-12 watch__featured-cards--items p-0" [ngClass]="{'fade-in': section.fadeIn}">
        <flo-watch-carousel>
          <ng-container *ngFor="let item of section.items; trackBy: trackByItem;">
            <div class="featured__rail__item">
              <flo-featured-content-card [props]="item"></flo-featured-content-card>
            </div>
          </ng-container>
        </flo-watch-carousel>
      </div>
    </ng-container>
    <ng-container *ngIf="section.items_style === 'small-card'">
      <div class="container watch__small-cards--header bg-900 mt-4">
        <div class="row d-flex justify-content-between align-items-end">
          <div class="watch__small-cards--title-description d-flex flex-column col-9 p-3 px-lg-0">
            <ng-container *ngIf="section.action?.url; else noSmallCardLink">
              <a
                floAnalytics
                elementName="Collection Name"
                class="watch__small-cards--title overtext font-family-heavy color-200 hover-grey-200 hover-underline mb-0 text-line-clamp-2"
                [routerLink]="section.action.url"
              >
                {{ section.title }}
              </a>
            </ng-container>
            <ng-template #noSmallCardLink>
              <h2 class="watch__large-cards--title overtext font-family-heavy color-200 mb-0 text-line-clamp-2">{{ section.title }}</h2>
            </ng-template>
            <span *ngIf="section.description" class="watch__small-cards--description footnote color-500">{{ section.description }}</span>
          </div>
          <div *ngIf="section.action" class="watch__small-cards--view-all d-flex justify-content-end col-3 px-0 py-md-3">
            <a
              floAnalytics
              tagName="Button"
              elementName="See All Videos"
              [analyticsProperties]="{ collection_name: section.title }"
              class="footnote p-3 p-md-0 color-500"
              [routerLink]="section.action.url"
            >
              {{ section.action.title }}
            </a>
          </div>
        </div>
      </div>
      <div class="watch__small-cards--items dark-theme col-12 p-0" [ngClass]="{'fade-in': section.fadeIn}">
        <flo-watch-carousel>
          <ng-container *ngFor="let item of section.items; trackBy: trackByItem;">
            <div class="small__rail__item p-0 me-3 image-opacity-hover">
              <flo-small-content-card [props]="item"></flo-small-content-card>
            </div>
          </ng-container>
        </flo-watch-carousel>
      </div>
    </ng-container>
  </ng-container>
  <div *ngIf="isLoading$ | async" class="d-flex spinner-container"><div class="spinner-border text-light d-flex m-auto"></div></div>
  <div floElementIsVisible [valueToOutput]="currentPage$ | async" (elementIsVisible)="emitNextPage($event)"></div>
  <flo-adhesion-footer>
    <div class="adhesion-ad d-sm-none">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adhesionAdProps"
      ></flo-lazy>
    </div>
  </flo-adhesion-footer>
</div>
